export const slider = () => {

    const popularPostsEl = document.querySelector('.popular-posts');
    if (popularPostsEl) {
        const swiper3 = new Swiper('.popular-posts', {
            wrapperClass: 'swiper-wrapper',
            slideClass: 'swiper-slide',
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            debug: false,
            loop: true,
            speed: 1000,
            autoplay: false,
            navigation: {
                nextEl: '.popular-posts__next',
                prevEl: '.popular-posts__prev',
            },
            breakpoints: {

                768: {
                    slidesPerView: 2,
                },
            },
        });
    }

    const ratingCardsEl = document.querySelector('.rating__cards');
    if (ratingCardsEl) {
        const swiper1 = new Swiper('.rating__cards', {
            wrapperClass: 'swiper-wrapper',
            slideClass: 'swiper-slide',
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: false,
            spaceBetween: 20,
            debug: false,
            loop: true,
            speed: 1000,
            autoplay: false,
            navigation: {
                nextEl: '.rating__next',
                prevEl: '.rating__prev',
            },
            breakpoints: {

                768: {
                    slidesPerView: 2,
                },

                1024: {
                    slidesPerView: 3,
                },
            },
        });
    }

    const trustedBrandsEl = document.querySelector('.trusted-brands');
    if (trustedBrandsEl) {
        const trustedBrandsMaian = new Swiper('.trusted-brands', {
            wrapperClass: 'trusted-brands__list',
            slideClass: 'trusted-brands__item',
            slidesPerView: 'auto',
            freeMode: true,
            loop: true,
            spaceBetween: 40,
            //centeredSlides: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            autoplayEnabled: false,
            debug: false,
        });
    }

    let swiper = null;
    const carouselContainerEl = document.querySelector('.carousel-container');
    if (carouselContainerEl) {
        swiper = new Swiper('.carousel-container', {
            wrapperClass: 'score',
            slideClass: 'score__item',
            debug: false,
            slidesPerView: 'auto',
            freeMode: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            autoplayEnabled: false,
        });
    }


    function checkAndToggleAutoplay() {
        if (!swiper) return;

        const containerWidth = swiper.el.clientWidth; // Ширина контейнера
        const totalSlidesWidth = Array.from(swiper.slides).reduce((acc, slide) => {
            return acc + slide.offsetWidth + swiper.params.spaceBetween;
        }, 0);


        if (swiper.slides.length > 6 || totalSlidesWidth > containerWidth) {
            swiper.autoplay.start();
        } else {
            swiper.autoplay.stop();
        }
    }

    checkAndToggleAutoplay();
    window.addEventListener('resize', checkAndToggleAutoplay);

} 